import React, { useEffect, useState } from 'react';
import { AssignmentStatus, TreatmentModel, TreatmentType } from '../models/superbit-api-models';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faTelegram, IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { faBan, faBell, faCheck, faCircle, faCircleCheck, faCircleExclamation, faCircleHalfStroke, faClock, faList, faPaperclip, faPhone, faRectangleXmark, faTasks, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, MenuProps, Tooltip } from 'antd';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { setEmailMessageId, setPopUpTreatmentModel, setTypeTreatmentsAction } from '../app-context/tasksSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LeadsModel } from '../models/LeadsModel';

type Props = {
    treatmentDetails: any;
    config: any;
    actions: any;
    fromLeadTableType?: boolean;
};

const ClientTreatmentEmail = (props: Props) => {
    const leadModel: LeadsModel = new LeadsModel();
    
    const [treatmentItem, setTreatmentItem] = useState<TreatmentModel>(props.treatmentDetails);
    const [clientItems, setClientItems] = useState<MenuProps['items']>([]);
    const [apiUrl, setApiUrl] = useState<string>('');
    const [additionalColumns, setAdditionalColumns] = useState<any>(props.config.additionalColumns);
    const [statusColor, setStatusColor] = useState<string>('grey');
    const [statusLabel, setStatusLabel] = useState<string>('');
    const [showStatus, setShowStatus] = useState<boolean>(true);
    const [treatmentNote, setTreatmentNote] = useState<string>('');
    const [statusIcon, setStatusIcon] = useState<IconDefinition>(faClock);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [createdBy, setCreatedBy] = useState<any>({});
    const [userData, setUserData] = useState<any>({});
    const [leadInfo, setLeadInfo] = useState<any>({});

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isValidUrl = (input: string): boolean => {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?.*)?(#.*)?$/i;
        return urlPattern.test(input);
    }

    const isHTML = (str: string): boolean => {
        const htmlPattern = /<\/?[a-z][\s\S]*>/i;
        return htmlPattern.test(str);
    }

    const downloadDocument = (docUrl: string | undefined) => {
        if (apiUrl !== '' && docUrl) {
            const fileUrl = `${apiUrl}${docUrl}`;
            console.log('downloadDocument', fileUrl);
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.target = '_blank';
            anchor.download = 'filename.pdf'; // Set the filename you want
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const emptyFunc = () => { }

    const onMenuClicked = (type: string) => {
        switch (type) {
            case 'edit':
                console.log('editTask');
                if (props.actions.edit) {
                    dispatch(setTypeTreatmentsAction("edit"));
                    dispatch(setEmailMessageId(treatmentItem.messageId ? treatmentItem.messageId : ''));
                    dispatch(setPopUpTreatmentModel({ show: true, type: 3 }));
                    props.actions.editEmail(treatmentItem.id);
                }
                break;
            case 'reference':
                if (props.actions.reference) {
                    props.actions.reference(treatmentItem.id);
                }
                break;
            case 'sendEmail':
                if (props.actions.sendEmail) {
                    props.actions.sendEmail(treatmentItem.id);
                }
                break;
            case 'sendWhatsApp':
                if (props.actions.sendWhatsApp) {
                    props.actions.sendWhatsApp(treatmentItem.id);
                }
                break;
            case 'print':
                if (props.actions.print) {
                    props.actions.print(treatmentItem.id);
                }
                break;
            case 'delete':
                if (props.actions.delete) {
                    props.actions.delete(treatmentItem.id);
                }
                break;
            case 'setPerformedStatus': {
                if (props.actions.setStatus) {
                    props.actions.setStatus(treatmentItem.id, 'd47d390a-5be2-42b4-b79f-13e6a4b14cef');
                }
                break;
            }

            case 'setNotYetPerformedStatus': {
                if (props.actions.setStatus) {
                    props.actions.setStatus(treatmentItem.id, '45cb3c16-f64f-40d5-9863-42a742ce4624');
                }
                break;
            }
            case 'redirtToClient':
                if (props.actions.redirectToClient) {
                    if (treatmentItem.leadRelatedId && treatmentItem.leadRelated) {
                        const lastLeadsFilter = localStorage.getItem('lastLeadsFilter');
                        if (lastLeadsFilter) {
                            const lastFilter = JSON.parse(lastLeadsFilter);
                            lastFilter.searchText = treatmentItem.leadRelated ? treatmentItem.leadRelated.phoneNumber1 : '';
                            localStorage.setItem('lastLeadsFilter', JSON.stringify(lastFilter));
                            navigate('/leads');
                            // props.actions.redirectToClient(treatmentItem.customer, lastFilter);
                        }
                    }
                    if (treatmentItem.customer) {
                        props.actions.redirectToClient(treatmentItem.customer);
                    }
                }
                break;
            default:
                break;
        }
    }

    const onShowDocument = () => {
        if (props.actions && props.actions.onShowDocument && treatmentItem.treatmentDocuments && treatmentItem.treatmentDocuments.length > 0) {
            props.actions.onShowDocument(apiUrl + "/" + treatmentItem.treatmentDocuments[0].filePath)
        }
    }

    useEffect(() => {
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        // console.log('ClientTreatment -> props changed')
        if (props.config.additionalColumns) {
            setAdditionalColumns(props.config.additionalColumns);
        }
    }, [props])

    useEffect(() => {
        getPersonalDetailsTreatments();
        
        const treatmentItem = props.treatmentDetails;
        if (!treatmentItem.assignmentStatus) {
            treatmentItem.assignmentStatus = AssignmentStatus.NotYetPerformed;
            setStatusColor('');
            setStatusLabel('');
        } else {
            const assignmentStatusId = treatmentItem.assignmentStatus.id;
            const assignmentStatusName: string = treatmentItem.assignmentStatus.name;
            setStatusLabel(assignmentStatusName);
            switch (assignmentStatusId) {
                case 'd47d390a-5be2-42b4-b79f-13e6a4b14cef': //AssignmentStatus.Performed:
                    setStatusColor('limegreen');
                    setStatusIcon(faCircleCheck)
                    break;
                    // case AssignmentStatus.NotifiedOnly: 
                    //     setShowStatus(false)
                    break;
                case '45cb3c16-f64f-40d5-9863-42a742ce4624': //(AssignmentStatus as any).NotYetPerformed:
                    if (moment(treatmentItem.endDate).format('YYYY-MM-DD') != '0001-01-01' && moment(treatmentItem.endDate).isBefore(moment())) {
                        setStatusColor('red');
                        // setStatusLabel('פיגור');
                    } else {
                        setStatusColor('green');
                    }
                    // setStatusLabel('טרם בוצעה');
                    break;
                case '773a54ec-0032-4485-afe5-6c8c8266dacd':
                    setStatusColor('grey');
                    break;
                // case '61b57b27-3e29-4fe0-a8cd-ecba91b99906': // AssignmentStatus.Pending:
                //     setStatusColor('red');
                //     break;

                default:
                    if (moment(treatmentItem.endDate).format('YYYY-MM-DD') != '0001-01-01' && moment(treatmentItem.endDate).isBefore(moment())) {
                        setStatusColor('red');
                        // setStatusLabel('פיגור');
                    } else {
                        setStatusColor('green');
                    }
                    break;
            }
        }
        if (treatmentItem.emailBody !== '') {
            // const activitiesLength = treatmentItem.treatmentActivities.length
            const notesText = treatmentItem.emailBody ? treatmentItem.emailBody.replace(/(<([^>]+)>)/gi, '').replace('&nbsp;', '') : '';

            setTreatmentNote(notesText);
        }
        if (treatmentItem) {

        } else {
            // if (treatmentItem.note) {
            //     setTreatmentNote(treatmentItem.note);
            // }
        }
        setTreatmentItem(treatmentItem);

        let isAdmin = false;
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            isAdmin = loggedUser.role == 0;
            setIsAdmin(isAdmin);
            // setCurrentUser(loggedUser);
        }


        let userList = localStorage.getItem('handlersList');
        let users: any[] = [];
        if (userList) {
            users = JSON.parse(userList);
            setUserData(users.find((user: any) => user.id == treatmentItem.belongsToId));
        }
        const menuOptions: MenuProps['items'] = [
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('edit') }}
                    >
                        עדכן
                    </li>,
                key: '1edit',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('reference') }}
                    >
                        שייך ל...
                    </li>,
                key: 'reference',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('setPerformedStatus') }}
                    >
                        סמן כבוצע
                    </li>,
                key: 'setPerformedStatus',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('setNotYetPerformedStatus') }}
                    >
                        סמן כלא בוצע
                    </li>,
                key: 'setNotYetPerformedStatus',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('sendEmail') }}
                    >
                        שלח אימייל
                    </li>,
                key: 'sendEmail',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('sendWhatsApp') }}
                    >
                        שלח וואצפ
                    </li>,
                key: 'sendWhatsApp',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('print') }}
                    >
                        הדפס
                    </li>,
                key: 'print',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('redirtToClient') }}
                    >
                        {treatmentItem.leadRelatedId && treatmentItem.leadRelatedId.length > 0 ? 'עבור לליד' : 'עבור לתיק לקוח'
                        }
                    </li>,
                key: 'print',
            }


        ];
        if (isAdmin) {
            menuOptions.push({
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('delete') }}
                    >
                        מחק
                    </li>,
                key: 'delete',
            })
        }


        if (treatmentItem.note && treatmentItem.note.includes('http://')) {
            setClientItems([])
        } else if (treatmentItem.treatmentType == 3) {
            //remove item from menuOptions
            var options = menuOptions.filter((item: any) => item.key !== 'sendWhatsApp' && item.key !== 'sendEmail' && item.key !== 'delete' && item.key !== 'changeHandler');
            setClientItems(options);
        } else if (treatmentItem.treatmentType == 2) {
            var options = menuOptions.filter((item: any) => item.key !== '1edit' && item.key !== 'changeHandler');
            setClientItems(options);
        } else {
            setClientItems(menuOptions);
        }
    }, [])


    const getPersonalDetailsTreatments = async () => {
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            const lead = await leadModel.getLeadForUpsert(treatmentItem.offerRelated.leadId);
            if (lead) {
                // return lead.firstName + ' ' + lead.lastName;
                setLeadInfo(lead);
            }
        }
    }

    const getIcon = () => {
        switch (treatmentItem.treatmentType) {
            case 3:
                return faEnvelope;
            // case TreatmentType.Email:
            //     return faEnvelope;
            // case TreatmentType.Meeting:
            //     return faHandshake;
            // case TreatmentType.Fax:
            //     return faFax;
            // case TreatmentType.SMS:
            //     return faSms;
            // case TreatmentType.Documentation:
            //     return faFileAlt;
            // case TreatmentType.Task:
            //     return faTasks;
            // case TreatmentType.Summary:
            //     return faClipboardList;
            // case TreatmentType.OutgoingMail:
            //     return faMailBulk;
            // case TreatmentType.Letter:
            //     return faEnvelopeOpenText;
            // case TreatmentType.Whatsapp:
            //     return faWhatsapp;
            // case TreatmentType.Telegram:
            //     return faTelegram;
            default:
                return faTasks;
        }
    }

    const getInsuranceCompanieById = (companyId: string) => {
        let insuranceCompaniesList = localStorage.getItem('insuranceCompanies');
        let insuranceCompanies: any[] = [];
        if (insuranceCompaniesList) {
            insuranceCompanies = JSON.parse(insuranceCompaniesList);
            let company = insuranceCompanies.find((company: any) => company.value == companyId);
            return company.label;
        }
        return '';
    }

    const getRefferenceInfo = () => {

        if (treatmentItem.policyRelatedId && treatmentItem.policyRelated) {
            let referrenceText = '';
            if (treatmentItem.policyRelated.policyNumber) {
                referrenceText = `פוליסה מספר: ${treatmentItem.policyRelated.policyNumber},`
            }
            if (treatmentItem.policyRelated.customer && treatmentItem.policyRelated.customer.vehicles && treatmentItem.policyRelated.customer.vehicles.length > 0) {
                referrenceText += ` מס' רכב: ${treatmentItem.policyRelated.customer.vehicles[0].licenseNumber},`
            }
            if (treatmentItem.policyRelated.insuranceCompanyId) {
                referrenceText += ` חברה: ${getInsuranceCompanieById(treatmentItem.policyRelated.insuranceCompanyId)}`
            }
            return referrenceText;
        }
        else if (treatmentItem.sueRelatedId && treatmentItem.sueRelated) {
            let referrenceText = '';
            if (treatmentItem.sueRelated.sueNumber && treatmentItem.sueRelated.customer) {
                referrenceText = `תביעה מספר: ${treatmentItem.sueRelated.sueNumber},`;
            }
            if (treatmentItem.sueRelated.customer && treatmentItem.sueRelated.customer.vehicles && treatmentItem.sueRelated.customer.vehicles.length > 0) {
                referrenceText += ` מס' רכב: ${treatmentItem.sueRelated.customer.vehicles[0].licenseNumber},`
            }
            if (treatmentItem.sueRelated.insuranceCompanyId) {
                referrenceText += ` חברה: ${getInsuranceCompanieById(treatmentItem.sueRelated.insuranceCompanyId)}`
            }
            return referrenceText;
        } else if (treatmentItem.leadRelatedId) {
            if (treatmentItem.leadRelated) {
                if (treatmentItem.leadRelated.identifier && treatmentItem.leadRelated.customer && treatmentItem.leadRelated.customer.vehicles && treatmentItem.leadRelated.customer.vehicles.length > 0) {
                    return `ליד מספר: ${treatmentItem.leadRelated.identifier}, מס' רכב: ${treatmentItem.leadRelated.customer.vehicles[0].licenseNumber},}`;
                }
            }
        }
        return '';

    }

    const getTreatmentType = (treatmentType: any) => {
        if (treatmentType == '1') {
            return 'משימה';
        } else if (treatmentType == '3') {
            return 'אימייל';
        } else if (treatmentType == '4') {
            return 'תיעוד';
        } else {
            return '';
        }
    }

    const getAgent = (agentId: string) => {
        let agentList = localStorage.getItem('agents');
        let agents: any[] = [];
        if (agentList) {
            agents = JSON.parse(agentList);
            let agent = agents.find((agent: any) => agent.id == agentId);
            return agent.name;
        }
        return '';
    }

    const getFullName = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.customer && treatmentItem.customer.fullName) {
            return treatmentItem.customer.fullName;
        }
        if (treatmentItem.leadRelated) {
            return treatmentItem.leadRelated.firstName || treatmentItem.leadRelated.lastName ?
                treatmentItem.leadRelated.firstName + ' ' + treatmentItem.leadRelated.lastName : '';
        }
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            return leadInfo.firstName || leadInfo.lastName ? leadInfo.firstName + ' ' + leadInfo.lastName : '';
        }
        return ''
    }


    const getIdentifier = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.customer && treatmentItem.customer.identifier) {
            return treatmentItem.customer.identifier;
        }
        if (treatmentItem.leadRelated) {
            return treatmentItem.leadRelated.identifier ? ` ${treatmentItem.leadRelated.identifier}` : '';
        }
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            return leadInfo.identifier ? ` ${leadInfo.identifier}` : '';
        }
        return ''
    }

    const getCreatedByFullName = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.updatedBy) {
            return treatmentItem.updatedBy.fullName;
        }
        if (treatmentItem.updatedById) {
            let userList = localStorage.getItem('usersList');
            let users: any[] = [];
            if (userList) {
                users = JSON.parse(userList);
                let user = users.find((user: any) => user.id == treatmentItem.updatedById);
                return user.fullName;
            }
        }
    }

    const getPhoneNumber = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.customer && treatmentItem.customer.customerContactDetails && treatmentItem.customer.customerContactDetails.length > 0
            && treatmentItem.customer.customerContactDetails[0].number) {
            return treatmentItem.customer.customerContactDetails[0].number;
        }
        if (treatmentItem.leadRelated) {
            return treatmentItem.leadRelated.phoneNumber1 ? ` ${treatmentItem.leadRelated.phoneNumber1}` : '';
        }
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            return leadInfo.phoneNumber1 ? ` ${leadInfo.phoneNumber1}` : '';
        }
        return ''
    }

    return (
        <Dropdown menu={{ items: clientItems }} trigger={['contextMenu']}>
            <div
                className={`data-card client-details-row client-item`}
                onDoubleClick={() => onMenuClicked('edit')}
            >
                <div className={`flex-centered ${treatmentItem.seen ? '' : 'unseen'}`}>
                    <div className="row-cell icon-cell">
                        {/* <div>
                        {
                            treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() && <FontAwesomeIcon icon={faBell} title={`${treatmentItem.alertDate}`} />
                        }
                        </div> */}
                        {/* <div style={{marginRight: '5px'}}> */}
                        {
                            <FontAwesomeIcon icon={getIcon()} title={`${getTreatmentType(treatmentItem.treatmentType)}`} />
                        }
                        {/* </div> */}

                    </div>
                    <div
                        className={`row-cell status ${statusColor}`}
                        style={{
                            color: `${statusColor}`,
                            fontSize: 'medium',
                            width: '130px',
                            textAlign: 'right',
                            direction: 'rtl',
                            display: 'flex',
                        }}
                    >
                        {showStatus && statusLabel.length > 0 &&
                            <>
                                <div className='status-icon'>
                                    <FontAwesomeIcon icon={statusIcon} />
                                </div>
                                <div>
                                    {statusLabel}
                                </div>
                            </>
                        }
                    </div>
                    <div className="row-cell client-name" style={{ display: props.fromLeadTableType && props.fromLeadTableType === true ? 'none' : '' }}>
                        <div className="description cell-value" style={{ whiteSpace: 'inherit' }} >
                            {treatmentItem.customer ?
                                (<>
                                    {treatmentItem.customer.fullName}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className="row-cell client-id" style={{ display: props.fromLeadTableType && props.fromLeadTableType === true ? 'none' : '' }}>
                        <div className="description cell-value">
                            {treatmentItem.customer ?
                                (<>
                                    {treatmentItem.customer.identifier}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className="row-cell created">
                        <div className="description cell-value">
                            {moment(treatmentItem.createdDate).format('DD-MM-YYYY')}
                        </div>
                        <div className="description">
                            {(moment(treatmentItem.createdDate)).format('HH:mm')}
                        </div>
                    </div>

                    <div className={`row-cell eventDate ${!additionalColumns || additionalColumns.eventDate.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {''}
                        </div>
                    </div>

                    <div className="row-cell alertDate">
                        <div className="description cell-value">
                            {treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() ? moment(treatmentItem.alertDate).format('DD-MM-YYYY') : ''}
                            {
                                treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() && <FontAwesomeIcon icon={faBell} title={`${treatmentItem.alertDate}`} />
                            }
                        </div>
                        <div className="description">
                            {treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() && (moment(treatmentItem.alertDate)).format('HH:mm')}
                        </div>
                    </div>
                    <div className={'row-cell alertDate endOfGoal'}>
                        <div className="description cell-value">
                            {treatmentItem.endDate && moment(treatmentItem.endDate).format('DD-MM-YYYY') !== '01-01-0001' ?
                                (<>
                                    {moment(treatmentItem.endDate).format('DD-MM-YYYY')}
                                </>) : (<></>)}
                        </div>
                        <div className="description">
                            {treatmentItem.endDate && moment(treatmentItem.endDate).format('DD-MM-YYYY') !== '01-01-0001' && (moment(treatmentItem.endDate)).format('HH:mm')}
                        </div>
                    </div>
                    <div className="row-cell topic" >
                        <div className="description cell-value" style={{ whiteSpace: 'inherit' }}>
                            {treatmentItem.topic ? (<>
                                {treatmentItem.topic}</>) : (<>
                                    ללא נושא
                                </>)}
                            {/* <span>&nbsp;</span> */}
                            {/* <FontAwesomeIcon icon={faPhone} /> */}
                        </div>
                    </div>
                    <div className="row-cell handler">
                        <div className="description cell-value">
                            {treatmentItem.belongsToId ?
                                (<>
                                    {treatmentItem.belongsToId ? userData.fullName : ' '}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className="row-cell treatment-note">
                        <div className="description cell-value">
                            {treatmentNote ? (<>
                                {isValidUrl(treatmentNote) ? <>
                                    <a href={treatmentNote} target='_blank'>לחץ לצפיה</a>
                                </> : <>
                                    {isHTML(treatmentNote) ? (
                                        <div dangerouslySetInnerHTML={{ __html: treatmentNote }} />
                                    ) :
                                        (<>

                                            <Tooltip title={() => {
                                                return (
                                                    treatmentItem.note != null && treatmentItem.note.indexOf('http://') > -1 ? (

                                                        <a target="_blank" href={treatmentItem.note}>{treatmentItem.note}</a>)

                                                        : treatmentItem.note && (
                                                            isHTML(treatmentItem.note) ? (

                                                                <div dangerouslySetInnerHTML={{ __html: treatmentItem.note }} />
                                                            ) :
                                                                <>
                                                                    {treatmentItem.note}
                                                                </>
                                                        )
                                                )
                                            }} color={'#027BFD'} placement="right">
                                                {/* {treatmentNote} */}
                                                <div className="icon comment"></div>
                                                {/* comment */}
                                            </Tooltip>
                                        </>)}
                                </>}
                            </>) : (<>

                            </>)}
                        </div>
                    </div>
                    <div className="row-cell creator">
                        <div className="description cell-value">
                            {treatmentItem.user ?
                                (<>
                                    {treatmentItem.user.fullName}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className="row-cell file icon-file-cell">
                        <div className="description cell-value">
                            {treatmentItem.treatmentDocuments && treatmentItem.treatmentDocuments.length > 0 ?
                                (<>
                                    <FontAwesomeIcon className='pointer' icon={faPaperclip} onClick={onShowDocument} />
                                </>) : (<></>)}
                        </div>
                    </div>
                    {/* <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.portfolio.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            
                        </div>
                    </div> */}
                    <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.agent.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {treatmentItem.agent ?
                                (<>
                                    {treatmentItem.agent.name}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.company.hidden ? 'hide' : ''}`}
                        style={{ display: props.fromLeadTableType && props.fromLeadTableType === true ? 'none' : '' }}
                    >
                        <div className="description cell-value">
                            {treatmentItem.company ?
                                (<>
                                    {treatmentItem.company.name}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className={`row-cell short client-name ${!additionalColumns || additionalColumns.modifiedBy.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {treatmentItem.updatedBy ?
                                (<>
                                    {treatmentItem.updatedBy.fullName}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className={`row-cell short changeDate ${!additionalColumns || additionalColumns.changeDate.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {treatmentItem.updatedDate ?
                                (<>
                                    {moment(treatmentItem.updatedDate).format('DD-MM-YYYY')}
                                </>) : (<></>)}
                        </div>
                    </div>
                    {!props.fromLeadTableType &&
                        <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.groups.hidden ? 'hide' : ''}`}
                            style={{ display: props.fromLeadTableType && props.fromLeadTableType === true ? 'none' : '' }}
                        >
                            <div className="description cell-value">

                            </div>
                        </div>
                    }
                    {!props.fromLeadTableType &&
                        <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.employer.hidden ? 'hide' : ''}`}
                            style={{ display: props.fromLeadTableType && props.fromLeadTableType === true ? 'none' : '' }}
                        >
                            <div className="description cell-value">

                            </div>
                        </div>
                    }
                    <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.referrence.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value" style={{ whiteSpace: 'inherit' }}>
                            {getRefferenceInfo()}
                            {/* {treatmentItem && treatmentItem.policyRelatedId ?'פוליסה' : treatmentItem.sueRelatedId ? 'תביעה' : treatmentItem.leadRelatedId ? 'ליד' : ''} */}
                        </div>
                    </div>


                    <div className="row-cell actions">
                        <Dropdown menu={{ items: clientItems }}>
                            <div className="act-btn-icon icon menu-hamburger pointer"></div>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </Dropdown>
    )
}

export default ClientTreatmentEmail;